import React from "react";
import { useSalon } from "../../../../context/SalonContext";
import { generateWalkInLink } from "../../../../utils/bookingLinkUtils";
import { CopyLinkIcon } from "../../../common/CopyLinkIcon";
import styles from "./Waitlist.module.css";

/**
 * Copy button for the location's walk-in waitlist (kiosk check-in) link,
 * placed after the walk-ins title + count badge. The URL itself isn't shown
 * (the tooltip says what's copied). Nothing renders until the salon loads.
 */
export const WalkInLink: React.FC = () => {
  const { businessInfo } = useSalon() as {
    businessInfo: { id: string } | null;
  };
  return (
    <CopyLinkIcon
      value={generateWalkInLink(businessInfo?.id)}
      label="Copy walk-in link"
      size={26}
      className={styles.walkInLinkCopy}
    />
  );
};

export default WalkInLink;
